import { hireflixCta, primaryGrey, white, yellow } from '@styles/colors';
import dayjs from 'dayjs';

export const getTrialDaysLeft = (trialStartDate?: string | null) => {
  if (!trialStartDate) return null;

  const start = dayjs(trialStartDate);
  const end = start.add(30, 'day');
  const left = end.diff(dayjs(), 'day');

  return left > 0 ? left : 0;
};

export const getStatusText = (status?: string) => {
  if (!status) return 'Trial not started';
  return status;
};

export const getStatusStyles = (status?: string) => {
  if (status === 'Trial') {
    return {
      bg: yellow,
      color: white,
    };
  }
  if (status === 'Paid') {
    return {
      bg: hireflixCta,
      color: white,
    };
  }

  return {
    bg: undefined,
    color: primaryGrey,
  };
};
